import { render, staticRenderFns } from "./KTable.vue?vue&type=template&id=7a8ce5e8&"
import script from "./KTable.vue?vue&type=script&lang=js&"
export * from "./KTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports